import script from "./new-edit-news-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./new-edit-news-modal.vue?vue&type=script&setup=true&lang=ts"

import "./new-edit-news-modal.vue?vue&type=style&index=0&id=cdcc0442&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdcc0442"]])

export default __exports__